<template>
  <dir v-resize="onResize" style="padding: 0; margin: 0">
    <div v-if="hasAlternative" style="border-bottom: 1px solid #eee; margin-bottom: 15px">
      <v-layout class="mb-2">
        <v-flex class="pl-3">
          <template v-if="input.randomStatus">
            {{ $t('Random chatbot answers') }}
          </template>
          <template v-else>
            {{ $t('Chatbot answers') }}
          </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <v-dialog v-model="showSetting" max-width="800" persistent>
            <v-card>
              <div class="text-xs-right">
                <v-btn small fab flat @click="showSetting = false"><v-icon>close</v-icon></v-btn>
              </div>
              <v-card-text>
                <template v-if="!isBeacon">
                  <div class="primary--text">
                    ตั้งค่าการตอบกลับหลายช่องทาง
                    <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
                  </div>
                  <v-radio-group
                    v-model="input.showMultipleChannel"
                    row
                    :disabled="
                      $store.getters.getPackage != 'premium' &&
                      selectedBot.pagetype !== 'enterprise'
                    "
                  >
                    <v-radio
                      label="ตอบเหมือนกันทุกช่องทาง"
                      :value="false"
                      color="primary"
                    ></v-radio>
                    <v-radio label="ตอบไม่เหมือนกัน" :value="true" color="primary"></v-radio>
                  </v-radio-group>
                </template>
                <template v-if="isBeacon">
                  <strong>{{ $t('How to set random chatbot responses?') }}</strong>
                  <ul>
                    <li>{{ $t('1. Press the “Random Answers” ​​button to turn green.') }}</li>
                    <li>
                      {{
                        $t(
                          '2. Choose 1-5 random answer patterns and put the desired answer in each format.^^'
                        )
                      }}
                    </li>
                  </ul>
                </template>

                <div class="primary--text mt-3">
                  {{ $t('Random answer') }}
                </div>
                <label
                  class="toggle-switch small"
                  style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                >
                  <input
                    type="checkbox"
                    :checked="input.randomStatus"
                    @change="toggleRandomStatus()"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="changeSetting">
                  {{ $t('Save') }}
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>

          <template v-if="isBeacon">
            <v-btn
              v-if="$route.name != 'Setup'"
              class="ma-0 extra-small"
              small
              outline
              color="primary"
              @click="showSetting = true"
            >
              {{ $t('Random answers') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="!hideSetting"
              class="ma-0 extra-small"
              fab
              flat
              small
              color="grey"
              @click="showSetting = true"
            >
              <v-icon>settings</v-icon>
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
    </div>
    <div ref="randomBar"></div>
    <template v-if="input.randomStatus">
      <!-- Random Intent -->
      <v-layout class="mb-2 primary lighten-4">
        <v-flex>
          <v-tabs
            v-model="currentAlternative"
            :show-arrows="true"
            color="primary lighten-4"
            slider-color="primary"
            :style="{ 'max-width': maxRandomBarWidth + 'px' }"
          >
            <v-tab v-for="n in intentItems.length" :key="n" ripple>
              {{ $t('pattern') }} {{ n }}
              <v-btn
                :disabled="intentItems.length == 1"
                fab
                flat
                small
                class="mr-0"
                style="width: 25px; height: 25px"
                @click="onDeleteAlternative(n)"
              >
                <v-icon small>close</v-icon>
              </v-btn>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex shrink>
          <v-btn
            v-tooltip.top="$t('In case, user wants to random reply messages')"
            class="extra-small mt-2"
            fab
            small
            outline
            color="black"
            :disabled="intentItems.length >= 5"
            @click="nextAlternative"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <div class="mt-2"></div>

    <div v-if="selectedBot.theme == 'ceemeagain' && $route.name == 'dashboard'">
      <template v-for="i in intentItems.length">
        <transition
          :key="`${i}_${timestamp}`"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
          <intent-group-item-ceeme-again
            v-show="currentAlternative == i - 1"
            :key="`${i}_${timestamp}`"
            v-model="intentItems[i - 1]"
            class="intent-group-item"
            :is-welcome="isWelcome"
            :index-alternative="i"
          ></intent-group-item-ceeme-again>
        </transition>
      </template>
    </div>
    <div v-else-if="selectedBot.theme == 'tero' && $route.name == 'template'">
      <template v-for="i in intentItems.length">
        <transition
          :key="`${i}_${timestamp}`"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
          <intent-group-item-tero
            v-show="currentAlternative == i - 1"
            :key="`${i}_${timestamp}`"
            v-model="intentItems[i - 1]"
            class="intent-group-item"
            :is-welcome="isWelcome"
            :max-intent="maxIntent"
            :index-alternative="i"
          ></intent-group-item-tero>
        </transition>
      </template>
    </div>
    <div v-else>
      <template v-for="i in intentItems.length">
        <transition
          :key="`${i}_${timestamp}`"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
          <intent-group-item
            v-show="currentAlternative == i - 1"
            :key="`${i}_${timestamp}`"
            v-model="intentItems[i - 1]"
            class="intent-group-item"
            :is-welcome="isWelcome"
            :index-alternative="i"
            :intentname="intentname"
            :available-bubbles="availableBubbles"
            :send-type="sendType"
            :max-intent="maxIntent"
            :is-beacon="isBeacon"
          ></intent-group-item>
        </transition>
      </template>
    </div>
  </dir>
</template>

<script>
import { mapGetters } from 'vuex'
import IntentGroupItem from './IntentGroupItem.vue'
import IntentGroupItemCeemeAgain from './IntentGroupItemCeemeAgain.vue'
import IntentGroupItemTero from './IntentGroupItemTero.vue'
import api from '@/api'
import Velocity from 'velocity-animate'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    IntentGroupItem,
    IntentGroupItemTero,
    IntentGroupItemCeemeAgain
  },
  inject: ['$validator'],
  props: {
    value: {
      default: ''
    },
    hasAlternative: {
      default: true,
      type: Boolean
    },
    isWelcome: {
      dafault: false,
      type: Boolean
    },
    intentname: {
      default: ''
    },
    showMultipleChannel: {
      default: false
    },
    tab: {
      default: 'all'
    },
    maxIntent: {
      default: 10
    },
    hideSetting: {
      default: false
    },
    availableBubbles: {},
    sendType: {
      default: 'promotion',
      type: String
    },
    isBeacon: {
      dafault: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      addLimit: this.maxIntent,
      group: '',
      intentItems: [],
      showEmoji: false,
      typingTimer: null,
      currentIndex: null,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentAlternative: 0,
      productlist: [],
      showSetting: false,
      input: {
        showMultipleChannel: false,
        randomStatus: false
      },
      timestamp: moment().format('x'),
      maxRandomBarWidth: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomeMessage: 'welcomeMessage'
    }),
    bubbleCount: function () {
      var vm = this

      if (vm.intentItems[vm.currentAlternative]) {
        var count = 0
        vm.intentItems[vm.currentAlternative].map((bubble) => {
          if (bubble.type == 'welcome_message') {
            if (vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
              count += vm.welcomeMessage.messages[0].length
            } else {
              count++
            }
          } else {
            count++
          }
        })
        return count
      } else {
        return 0
      }
    }
  },
  watch: {
    group: function () {
      this.$emit('input', this.group)
    },
    value: function () {
      var vm = this
      vm.group = vm.value
      vm.intentItems = vm.group
    }
  },
  created: function () {
    this.group = this.value
    this.intentItems = this.group ? this.group : []
  },

  mounted() {
    this.$set(this.input, 'showMultipleChannel', this.showMultipleChannel)
    if (this.intentItems.length > 1) this.$set(this.input, 'randomStatus', true)
    this.onResize()
  },

  methods: {
    onResize() {
      if (this.$refs.randomBar) {
        let randomBarWidth = this.$refs.randomBar.clientWidth
        let addRandomBtnWidth = 48
        this.maxRandomBarWidth = randomBarWidth - addRandomBtnWidth
      }
    },
    onDeleteAlternative(alternative) {
      if (this.intentItems.length > 1) {
        this.intentItems.splice(alternative - 1, 1)
      }
      this.timestamp = moment().format('x')
    },
    toggleRandomStatus() {
      this.$set(this.input, 'randomStatus', !this.input.randomStatus)
    },
    changeSetting() {
      this.$emit('changeSetting', this.input)
      this.showSetting = false
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      setTimeout(() => {
        el.style.height = '100%'
        setTimeout(() => {
          Velocity(el, { opacity: 1, translateY: '10px' }, { complete: done, duration: 500 })
        }, 100)
      }, 600)
    },
    afterEnter: function () {
      //
    },
    beforeLeave: function (el) {
      el.style.opacity = 1
      // el.style.maxHeight = 'none'
    },
    leave: function (el, done) {
      Velocity(el, { opacity: 0, translateY: '-10px' }, { complete: done, duration: 500 })
    },
    afterLeave: function () {
      // el.style.maxHeight = 0
    },
    getProducts: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      vm.productlist = []
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }
      api.getProducts(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.productlist = response.productlist
        callback()
      })
    },

    nextAlternative: async function () {
      var intent = cloneDeep(this.intentItems[this.currentAlternative])
      this.intentItems.push(intent)
      await this.$nextTick()
      this.currentAlternative = this.intentItems.length - 1
      this.updateIntent()
      this.timestamp = moment().format('x')
    },
    addAlternativeMessnage: function () {
      this.intentItems.push([])
      this.currentAlternative = this.intentItems.length - 1
      this.updateIntent()
    },
    deleteAlternativeMessage: function (index) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: 'Pattern' + (index + 1)
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.intentItems.splice(index, 1)
            vm.currentAlternative = index - 1
            vm.updateIntent()
          }
        })
    },
    addIntentPrefill: function (index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.intentItems[index][subindex].type === 'text') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      } else if (vm.intentItems[index][subindex].type == 'button') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      }
      vm.updateIntent()
    },
    addIntentItem: function (type, index) {
      if (this.bubbleCount >= this.addLimit) {
        return false
      }
      if (type == 'text') {
        this.intentItems[index].push({
          text: '',
          type: type
        })
      } else if (type == 'button') {
        this.intentItems[index].push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image') {
        this.intentItems[index].push({
          image_url: '',
          type: type
        })
      } else if (type == 'generic') {
        this.intentItems[index].push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'welcome_message') {
        this.intentItems[index].push({
          type: type
        })
      } else if (type == 'viewsummary') {
        if (this.productlist.length == 0) {
          return false
        }
        this.intentItems[index].push({
          type: 'text',
          text: '{viewsummary}'
        })
      }
      this.updateIntent()
    },
    onDelete: function (index, subindex) {
      this.intentItems[index].splice(subindex, 1)
      this.updateIntent()
    },

    onMove: function (index, subindex, direction) {
      var vm = this
      if (direction == 'up') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex - 1, 1)[0])
      } else if (direction == 'down') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex + 1, 1)[0])
      }
      this.updateIntent()
    },
    onTyping: function () {
      // clearTimeout(this.typingTimer);
      // this.typingTimer = setTimeout(this.updateIntent(), 1000)
      this.updateIntent()
    },
    updateIntent: function () {
      let vm = this
      vm.group = vm.intentItems
    },
    addNewButton: function (index, subindex, payload) {
      if (this.intentItems[index][subindex].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.intentItems[index][subindex].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        this.updateIntent()
      }
    },
    editButton: function (index, subindex, bindex, payload) {
      if (this.intentItems[index][subindex].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.intentItems[index][subindex].buttons, bindex, payload)
        this.updateIntent()
      }
    },
    deleteButton: function (index, subindex, bindex) {
      // if (this.intentItems.length >= 1) {
      //     return false
      // }
      this.intentItems[index][subindex].buttons.splice(bindex, 1)
      this.updateIntent()
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-group-item {
  transition: height ease 2s;
  -webkit-transition: height ease 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGroup.vue